import { render, staticRenderFns } from "./RatingForm.vue?vue&type=template&id=206cd278&scoped=true&"
import script from "./RatingForm.vue?vue&type=script&lang=js&"
export * from "./RatingForm.vue?vue&type=script&lang=js&"
import style0 from "./RatingForm.vue?vue&type=style&index=0&id=206cd278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cd278",
  null
  
)

export default component.exports